import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useEffect } from "preact/hooks";
import CartBody from "./CartBody";
import CartFooter from "./CartFooter";
import CartHeader from "./CartHeader";
import CartImage from "./CartImage";
function Cart(props) {
    const { state, imageUrn } = props;
    const hasImage = !!imageUrn;
    const isSubmitDisabled = !state.cart.isReadyForCheckout;
    const isContinueVisible = !(window.Skubacz.Device.screen.isExtraSmall() &&
        !state.cart.hasError &&
        !state.cart.isEmpty);
    useEffect(() => {
        state.cart.initialize();
        return () => state.cart.dispose();
    }, []);
    return (h(Fragment, null,
        hasImage && h(CartImage, { imageUrn: imageUrn }),
        h(CartHeader, { isClearVisible: !state.cart.isEmpty, onClear: () => state.cart.clear(), onClose: () => state.hideModal() }),
        h(CartBody, { state: state }),
        h(CartFooter, { price: state.cart.price, isSubmitDisabled: isSubmitDisabled, isContinueVisible: isContinueVisible, onContinue: () => state.hideModal(), onSubmit: () => state.goToCheckout(isSubmitDisabled) })));
}
export default observer(Cart);
